// Module
var code = `<!-- AUTHOR AND OBSERVE -->
<section class="author-observe" aria-labelledby="author-observe-headline">

  <div class="author-observe__inner">

    <header class="author-observe__header">
      <p class="author-observe__label">Author and observe</p>
      <h2 id="author-observe-headline" class="author-observe__headline">
        Shape your content. See your application.
      </h2>
      <p class="author-observe__sub">
        SpyneJS brings content authoring and runtime visibility into the same
        environment — the beginning of a production content platform where developers
        no longer have to choose between structure and editorial control.
      </p>
    </header>

    <div class="author-observe__split">

      <!-- Live CMS -->
      <article class="author-observe__panel">
        <header class="author-observe__panel-header">
          <p class="author-observe__panel-label">Live CMS</p>
          <h3 class="author-observe__panel-title">Multi-source content editor</h3>
          <p class="author-observe__panel-desc">
            A full content editor built into the framework. Author, edit, and publish
            without leaving your application environment.
          </p>
        </header>

        <ul class="author-observe__panel-body" aria-label="CMS features">
          <li class="author-observe__feature">
            <span class="author-observe__feature-dot" aria-hidden="true"></span>
            <p class="author-observe__feature-text">
              <strong>WYSIWYG live editing</strong> — changes render in the application
              as you make them, with no preview step.
            </p>
          </li>
          <li class="author-observe__feature">
            <span class="author-observe__feature-dot" aria-hidden="true"></span>
            <p class="author-observe__feature-text">
              <strong>Multi-source data</strong> — combine content from multiple external
              sources in a single editor view. No custom data layer required.
            </p>
          </li>
          <li class="author-observe__feature">
            <span class="author-observe__feature-dot" aria-hidden="true"></span>
            <p class="author-observe__feature-text">
              <strong>Rich text editor</strong> — built in and ready to use. No plugins
              to configure, no third-party editor to integrate.
            </p>
          </li>
          <li class="author-observe__feature">
            <span class="author-observe__feature-dot author-observe__feature-dot--ai" aria-hidden="true"></span>
            <p class="author-observe__feature-text">
              <strong>Copy prompt</strong> — generates a contextual AI prompt for any
              content section. Paste it into Claude, ChatGPT, or your own model to return
              updated content that already fits the section's structure.
            </p>
          </li>
        </ul>

        <footer class="author-observe__panel-footer">
          <div class="author-observe__callout">
            <p class="author-observe__callout-label">How structured prompts work</p>
            <p class="author-observe__callout-text">
              Select any field in the CMS → generate a prompt → paste it into your AI
              tool of choice → paste the result back. The prompt includes the section's
              structural context, so the response fits the content model without manual
              reformatting.
            </p>
          </div>
        </footer>
      </article>

      <!-- Behavior Console -->
      <article class="author-observe__panel">
        <header class="author-observe__panel-header">
          <p class="author-observe__panel-label">Behavior Console</p>
          <h3 class="author-observe__panel-title">Every channel. Every event. Live.</h3>
          <p class="author-observe__panel-desc">
            Inspect what your application is doing at every layer, in real time.
          </p>
        </header>

        <figure class="author-observe__console-figure">
          <img
            src="https://assetscontainer.com/assets/imgs/behavior-console-V1.png"
            alt="SpyneJS Behavior Console showing live channel events — UI, Window, Route, Lifecycle, AI and other channels with real-time JSON payload output"
            class="author-observe__console-image"
            loading="lazy"
            decoding="async"
          >
          <div class="author-observe__console-fade" aria-hidden="true"></div>
        </figure>

        <figcaption class="author-observe__console-caption">
          Select any channel to inspect the behavior layer in real time. Payloads
          display in full — every action, every state change, traceable as it happens.
        </figcaption>

      </article>

    </div>

  </div>

</section>
`;
// Exports
module.exports = code;